import './style.scss'
import { useEffect, useState } from "react"
import { AppText, Circle, CustomContainer, FlexRow, RoundImageContainer } from "src/style"

interface IRadioButton {
    options: Array<string|number>,
    height?: string,
    width?: string,
    noDefault?: boolean,
    value?: string
    output(val: string|number): any,
    className?: string,
    hasStartRingPosition?: boolean
}

export const RadioSelection: React.FC<IRadioButton> = ({options, height, output, noDefault, value, className, width, hasStartRingPosition}) => {
    const [input, setInput] = useState(noDefault ? '' : options[0])

    useEffect(() => {
        if (value) setInput(value)
    }, [value])
    
    function handleSelection (option: string|number) {
        setInput(option)
        output && output(option)
    }

    return (
        <>
            <FlexRow justifyContent="space-between" wrap='wrap'>
                { options?.length &&
                    options?.map((item: string|number) => {
                        return (
                            <CustomContainer
                                width={width || String((100 - (options.length + (options.length * 0.5))) / options.length)} sizeUnit="%" 
                                minHeight={height || "3.6"} bottomMargin="1" 
                                className={`radio-selection-container ${className}`} key={item}
                                borderColor={input === item ? '#0D968F' : '#EAECF0'}
                                bgColor={input === item ? '#E7F6F5' : 'transparent'}
                                onClick={() => handleSelection(item)}
                            >
                                <FlexRow justifyContent="flex-start" alignItems={hasStartRingPosition ? 'flex-start' : 'center'}>
                                    <RoundImageContainer 
                                        size="1.6" 
                                        borderColor={input === item ? '#0D968F' : '#EAECF0'}
                                        bgColor={input === item ? '#E7F6F5' : 'transparent'}
                                        rightMargin="1" 
                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}
                                        className={hasStartRingPosition ? 'radio-ring-start-position' : ''}
                                    >
                                        { input === item && <Circle bgColor="#0D968F" size='0.6' /> }
                                    </RoundImageContainer>
                                    <AppText 
                                        textSize="1.4" fontWeight="600" cursor="pointer"
                                        color={input === item ? '#085B56' : '#344054'}
                                    >
                                        {item}
                                    </AppText>
                                </FlexRow>
                            </CustomContainer>
                        )
                    })
                }
            </FlexRow>
        </>
    )
}